import MUIAccordionDetails from '@mui/material/AccordionDetails'

export const AccordionDetails = MUIAccordionDetails
